// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"ecb9dc23","787":"2dca78c1","858":"676654f7"}[chunkId] + ".chunk.js";
};